import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  separator: {
    color: 'rgba(126, 126, 143, 1)',
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  },
  vertical: {
    flexDirection: 'column',
    height: '200px',
    maxWidth: '30px'
  },
  horizontal: {
    flexDirection: 'row',
    width: '100%',
  },
  'separatorLine-vertical': {
    borderLeft: '1px solid rgba(226, 226, 234, 1)',
    height: '100px',
  },
  'separatorLine-horizontal': {
    borderTop: '1px solid rgba(226, 226, 234, 1)',
    width: "50%",
  },
}));

export default useStyles;
